import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import { getIncomingInvoicesFromPoItem } from "../../../../services/finance/incomingInvoice";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function IncomingInvoicePoItemList({ poItemID = 0 }) {
  const { reload } = useGlobalData();
  const [incomingInvoiceItem, setIncomingInvoiceItem] = useState([]);
  useEffect(() => {
    getIncomingInvoicesPoItemData(poItemID);
  }, [poItemID, reload]);

  const incomingInvoicePoItemDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <CustomDataTable
      data={incomingInvoiceItem}
      dataDetailColumns={incomingInvoicePoItemDetailColumn}
      onRefreshData={() => {
        getIncomingInvoicesPoItemData(poItemID);
      }}
      columns={[
        {
          header: "A/R Invoice ID",
          field: "incomingInvoiceID",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Invoice Date",
          field: "incomingInvoice.invoiceDate",
          body: (rowData) => formatDate(rowData.incomingInvoice.invoiceDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Deadline Date",
          field: "incomingInvoice.deadlineDate",
          body: (rowData) => formatDate(rowData.incomingInvoice.deadlineDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Quantity",
          field: "qty",
          body: (rowData) => (
            <div>
              {rowData.qty} {rowData.uom.uom}
            </div>
          ),
          sortable: true,
          filter: true,
        },
        {
          header: "Unit",
          field: "uom.uom",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Currency",
          field: "incomingInvoice.currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Item Amount",
          field: "totalPrice",
          body: (rowData) => (
            <NumberFormat
              value={rowData.totalPrice}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.incomingInvoice.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
          filter: true,
        },
      ]}
    />
  );

  async function getIncomingInvoicesPoItemData(poItemID = 0) {
    if (poItemID > 0) {
      const response = await getIncomingInvoicesFromPoItem(poItemID);
      const { data } = response.data;
      setIncomingInvoiceItem(data.incomingInvoiceItem);
    }
  }
}

export default IncomingInvoicePoItemList;
